import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { useAppContext, screenBreakpoints } from 'App/app-context';
const ResponsiveTooltip = ({ title, placement, children, onOpenChange, open, }) => {
    const { screenSize } = useAppContext();
    return (_jsx(Tooltip, { title: screenSize.width < screenBreakpoints.lg ? false : title, placement: placement, trigger: ['hover', 'focus'], onOpenChange: onOpenChange, open: open, children: children }));
};
export default ResponsiveTooltip;
